import { render, staticRenderFns } from "./AtsCandidate.vue?vue&type=template&id=5f59e842&scoped=true"
import script from "./AtsCandidate.vue?vue&type=script&setup=true&lang=js"
export * from "./AtsCandidate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AtsCandidate.vue?vue&type=style&index=0&id=5f59e842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f59e842",
  null
  
)

export default component.exports